export default "__VITE_ASSET__DGqxzaI0__"